import React from 'react';
import { Link } from 'react-router-dom';

const DoctorManagementMenu = ({
    activeMenu = ''
}) => {
    return (
        <div className="inner-menu-container bg-white shadow-sm">
            <div className="container-fluid px-lg-5">
                <ul className="nav secondary-menu mw-100 flex-nowrap gap-xl-5 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/doctors/list" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'doctors' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Doctors
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/patients/list" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'patients' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Patients
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/treatments" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'treatments' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Treatments
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/healthCenter" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'healthCenter' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Health Centers
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/medicines" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'medicines' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Medicines
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/inventory" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'inventory' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Inventory
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/prescriptions" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'prescriptions' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Prescriptions
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/vaccinations" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'vaccination' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Vaccination
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to="/timeline" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'appointments' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Appointments / Timeline
                        </Link>
                    </li>
                     <li className="nav-item flex-fill">
                        <Link 
                            to="/billable-activities" 
                            className={`d-block text-black text-decoration-none py-3 py-sm-4 position-relative ${
                                activeMenu === 'billableActivities' 
                                    ? 'active' 
                                    : ''
                            }`}
                        >
                            Billable Activities
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default DoctorManagementMenu;